export function getFirstName(fullName: string): string {
  const tokens = fullName.split(/\s+/);

  return tokens[0];
}

export function getLastName(fullName: string): string {
  const tokens = fullName.split(/\s+/);

  if (tokens.length <= 1) {
    return "";
  }

  return tokens[tokens.length - 1];
}

export function getMiddleName(fullName: string): string {
  const tokens = fullName.split(/\s+/);

  if (tokens.length <= 2) {
    return "";
  }

  const middleNameTokens = tokens.slice(1, tokens.length - 1);
  return middleNameTokens.join(" ");
}

export function joinNameParts(firstName: string, lastName: string): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}
